/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const mobileMenu = navigation.querySelector('.fb-mobile-menu');

    const closeMenu = function () {
        navigation.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Open menu');
    };

    burger.addEventListener('click', function () {
        const isOpen = navigation.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', String(isOpen));
        burger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });

    mobileMenu?.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth >= 1024) closeMenu();
    });
})();

/* FastBots desktop dropdown controls */
(function () {
    const navigation = document.querySelector('[data-fastbots-navigation]');
    if (!navigation) return;

    const dropdowns = Array.from(navigation.querySelectorAll('.fb-navigation-dropdown > details'));

    dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('toggle', function () {
            if (!dropdown.open) return;

            dropdowns.forEach(function (otherDropdown) {
                if (otherDropdown !== dropdown) otherDropdown.removeAttribute('open');
            });
        });
    });

    document.addEventListener('click', function (event) {
        if (navigation.contains(event.target)) return;
        dropdowns.forEach(function (dropdown) {
            dropdown.removeAttribute('open');
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;

        dropdowns.forEach(function (dropdown) {
            if (!dropdown.open) return;
            dropdown.removeAttribute('open');
            dropdown.querySelector('summary')?.focus();
        });
    });
})();

/* Keep the global footer year current without inheriting a post's publish date */
(function () {
    document.querySelectorAll('[data-current-year]').forEach(function (year) {
        year.textContent = new Date().getFullYear();
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
